import { getStore } from '../../store';
import { SessionStore } from '../../constants';

/** Get Project Id from Session Storage */
export const getProjectId = (): number | undefined => {
  const workflowSession = getStore()?.state?.workflowSession;
  if (workflowSession) return workflowSession.projectId;
};

export const updateSessionStoreBooleanValue = (storekey: SessionStore, key: string, newValue: boolean) => {
  const storeValue = sessionStorage.getItem(storekey);
  const value = storeValue && JSON.parse(storeValue);
  value[key] = newValue;
  sessionStorage.setItem(storekey, JSON.stringify(value));
};
